import React, { PureComponent } from 'react'
import { array, shape } from 'prop-types'
import { createComponent, withTheme, ThemeProvider } from '@ycos/fela'
import { Grid } from '@ycos/component-grid'

class Divider extends PureComponent {
  static layoutVariant = ['isc-divider', 'isc-divider-section', 'isc-divider-40-64']

  render() {
    const { item: { layoutVariant } = {}, theme } = this.props

    if (layoutVariant === 'isc-divider-section') {
      return (
        <ThemeProvider theme={{ ...theme, direction: 'ltr' }}>
          <Grid.Row>
            <Grid.Span>
              <StyledRule data-automation="component-divider" large />
            </Grid.Span>
          </Grid.Row>
        </ThemeProvider>
      )
    }

    if (layoutVariant === 'isc-divider-40-64') {
      return (
        <ThemeProvider theme={{ ...theme, direction: 'ltr' }}>
          <Grid.Row>
            <Grid.Span>
              <StyledRule data-automation="component-divider" responsive />
            </Grid.Span>
          </Grid.Row>
        </ThemeProvider>
      )
    }

    return <StyledRule data-automation="component-divider" />
  }
}

Divider.propTypes = {
  item: shape({
    layoutVariant: array.isRequired
  }).isRequired
}

const StyledRule = createComponent(
  'hr',
  ({ theme, large, responsive }) => {
    const { spacingMultiplier, custom } = theme
    const largeMargin = 6 * spacingMultiplier // 48px
    const smallMargin = 3 * spacingMultiplier // 24px
    const responsiveMobileMargin = 5 * spacingMultiplier // 40px  mobile
    const responsiveDesktopMargin = 8 * spacingMultiplier // 64px desktop 
    return {
      margin: responsive ? `${responsiveMobileMargin}px 0 0 0` : `${large ? largeMargin : smallMargin}px 0 ${large ? 0 : smallMargin}px 0`,
      border: 0,
      height: '1px',
      background: custom.divider.color,
      'screen-medium': {
        margin: responsive ? `${responsiveDesktopMargin}px 0 0 0` : `${large ? largeMargin : smallMargin}px 0 ${large ? 0 : smallMargin}px 0`,

      }
    }
  },
  'hr'
)

export default withTheme(Divider)
